import { render, staticRenderFns } from "./TransformerLoad.vue?vue&type=template&id=dedfba3a&scoped=true&"
import script from "./TransformerLoad.vue?vue&type=script&lang=js&"
export * from "./TransformerLoad.vue?vue&type=script&lang=js&"
import style0 from "./TransformerLoad.vue?vue&type=style&index=0&id=dedfba3a&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dedfba3a",
  null
  
)

export default component.exports